var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91671 9.91675V11.0834C9.91671 11.4056 10.1779 11.6667 10.5 11.6667C10.8222 11.6667 11.0834 11.4056 11.0834 11.0834V2.33341H2.91671V8.75008H1.75004V1.75008C1.75004 1.42792 2.01121 1.16675 2.33337 1.16675H11.6667C11.9889 1.16675 12.25 1.42792 12.25 1.75008V11.0834C12.25 12.0499 11.4666 12.8334 10.5 12.8334H2.33337C1.36688 12.8334 0.583374 12.0499 0.583374 11.0834V9.91675H9.91671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostDetails);
export default __webpack_public_path__ + "static/media/post-details.a26eb3d5ba39e12f00da77342106ea5f.svg";
export { ForwardRef as ReactComponent };